import * as React from 'react';
import classNames from 'classnames';
import './likesLogo.module.scss';
import { LikesLogoSvg } from './LikesLogoSvg';

// eslint-disable-next-line no-unused-vars
export const Logo = ({ className = undefined, styleName = undefined, onClick = undefined }) => (
    <LikesLogoSvg className={className} onClick={onClick} />
);

export const HeaderLogo = ({ color }) => <Logo styleName={classNames('header-logo', color)} />;

type Props = {
    styleName?: string;
    className?: string;
    color?: 'white' | 'dark';
    onClick?: () => any;
};

export const LikesLogo = ({ className, color = 'dark', onClick }: Props) => {
    return (
        <div styleName={classNames('logo', color)} className={className} onClick={onClick}>
            <HeaderLogo color={color} />
        </div>
    );
};
